import Hotjar from '@hotjar/browser';

if (process.env.VUE_APP_HOTJAR_ENABLED === 'true') {
  Hotjar.init(process.env.VUE_APP_HOTJAR_SITEID, process.env.VUE_APP_HOTJAR_VERSION);
}
